import React from 'react';
import { Button, ButtonAsButtonProps } from '../../../buttons';

export type ModalConfirmButtonProps = ButtonAsButtonProps;

export const ModalConfirmButton: React.FC<ModalConfirmButtonProps> = ({
  ...rest
}) => {
  return (
    <Button
      className="w-full sm:ml-3 sm:w-auto"
      layout="squared"
      variant="primary"
      type="submit"
      {...rest}
    />
  );
};
